import type { ChatTurnProps } from "../../types/chat";

// Nothing to ask with a credit already running: its screen opens straight
// away.
export const getActiveLoanScreen = (props: ChatTurnProps): string =>
  props.step.screen.entry(props.facts);
